import React, {useEffect, useState} from "react";
import {connect} from 'react-redux';
import { useTranslation } from 'react-i18next';
import {withRouter} from "react-router-dom";
import ContactEditEmailRows from "./components/contact-edit-email-rows";
import ContactEditPhoneRows from "./components/contact-edit-phone-rows";
import ContactEditPostalAddressRows from "./components/contact-edit-postal-address-rows";
import Avatar from "../../../../../../../../components/avatar";
import Icon from "../../../../../../../../components/icon";
import Button from "../../../../../../../../components/button";
import {contactDetailsEditMode, putUpdateContact} from "../../../../../../../../../actions/contactActions";
import Input from "../../../../../../../../components/input";
import './index.css';

function ContactEdit (props) {

    const [isSubmitting, setIsSubmitting] = useState(false);
	const [readFile, setReadFile] = useState("");

    const { t } = useTranslation();

    const {
        findContactDetails,
        setContactDetailsEditMode,
        putUpdateContact,
        sharingDetailsPopup,
	    selectedContactsGroup,
        contactSearchResult,
        checkGmailAddOnData,
        customFieldsForContactForm,
	    profile
    } = props;

    const {action,contactEmail} = checkGmailAddOnData;
    const goBackToView = () => {
        if(action && contactEmail){
            window.close();
        }

        setContactDetailsEditMode(false);
        props.history.push('/contact/' + findContactDetails.id);
    };

    const browseHandler = (e) => {

        let file = e.target.files[0];
        let reader = new FileReader();

        reader.addEventListener('load', () => {
           setReadFile(reader.result.split(',')[1]);
        });

        if(file){
	        reader.readAsDataURL(file);
        }

    };

	const clickHandler = (e) => {
		e.currentTarget.previousSibling.click();
	};

    const proceed = (e) => {
        e.preventDefault();

        setIsSubmitting(true);

        const {
            prefix,
            givenName,
            middleName,
            familyName,
            suffix,
            company,
            jobTitle,
            department,
            description,
            birthday
        } = e.currentTarget.elements;

        let emailValues = [];

        document.querySelectorAll('.contact-edit-email-row').forEach(item => {
            emailValues = emailValues.concat({
                "label" : item.children[2].children[0].value,
                "email" : item.children[1].children[0].value
            })
        });

        let phoneValues = [];

        document.querySelectorAll('.contact-edit-phone-row').forEach(item => {
            phoneValues = phoneValues.concat({
                "label" : item.children[2].children[0].value,
                "number" : item.children[1].children[0].value
            })
        });

        let postalAddressValues = [];

        document.querySelectorAll('.contact-edit-postal-address-row').forEach(item => {
            postalAddressValues = postalAddressValues.concat({
                "street" : item.children[1].children[0].children[0].children[0].value,
	            "neighborhood" : item.children[1].children[0].children[1].children[0].value,
                "postCode" : item.children[1].children[0].children[2].children[0].value,
                "city" : item.children[1].children[1].children[0].children[0].value,
	            "label" : item.children[1].children[1].children[1].children[0].value,
	            "countryCode" : item.children[1].children[2].children[0].children[0].value,
	            "state" : item.children[1].children[2].children[1].children[0].value
            })
        });

        let addableFieldValues = [];

	    document.querySelectorAll('.contact-edit-addable-field-row').forEach(item => {
		    addableFieldValues = addableFieldValues.concat({
			    "type" : item.querySelector('.type-field').children[0].value,
			    "category" : item.querySelector('.category-field') ? item.querySelector('.category-field').children[0].value : "",
			    "value" : item.querySelector('.value-field').children[0].value,
		    })
	    });

        let customFieldValues = [];

        document.querySelectorAll('.contact-edit-custom-field').forEach((item, index) => {
            if(item.children[1].children[1].value.trim() !== ""){
                customFieldValues = customFieldValues.concat({
                    "key" : findContactDetails.phoneContactEntry.userDefined[index].key,
                    "value" : item.children[1].children[1].value
                })
            }
        });

        let payload = {
            "labels":[],
            "imageString": readFile,
            "phoneContactEntry":{
                "prefix": prefix.value,
                "givenName": givenName.value,
                "middleName": middleName.value,
                "familyName": familyName.value,
                "suffix": suffix.value,
                "company": company.value,
                "jobTitle": jobTitle.value,
                "department": department.value,
                "emailAddresses": emailValues,
                "phoneNumbers": phoneValues,
                "postalAddresses": postalAddressValues,
                "note": description.value,
                "birthday": {
                    "day": birthday.value.split('-')[2],
                    "month": birthday.value.split('-')[1],
                    "year": birthday.value.split('-')[0]
                },
                "userDefined": customFieldValues
            },
        };

        let ownerId = contactSearchResult?.contacts.length? '' : selectedContactsGroup.ownerId;
        let contactId = null;

        if(sharingDetailsPopup[2]){
	        contactId = sharingDetailsPopup[2][0].id
        } else {
            contactId = findContactDetails.id
        }

        putUpdateContact(
	        contactId,
            payload,
            ownerId
        )

    };

    useEffect(() => {
        if(findContactDetails.phoneContactEntry.birthday){
            let dayValue = findContactDetails.phoneContactEntry.birthday.day <= 9 ? '0' + findContactDetails.phoneContactEntry.birthday.day : findContactDetails.phoneContactEntry.birthday.day;
            let monthValue = findContactDetails.phoneContactEntry.birthday.month <= 9 ? '0' + findContactDetails.phoneContactEntry.birthday.month : findContactDetails.phoneContactEntry.birthday.month;
            let yearValue = findContactDetails.phoneContactEntry.birthday.year.toString();

            document.getElementById('birthday').value = `${yearValue}-${monthValue}-${dayValue}`;
        }
    }, [findContactDetails.phoneContactEntry.birthday]);

    return (
        <div className="contact-edit">
            {
                findContactDetails.phoneContactEntry.type === "directory" && <div className="alert alert-warning">
                    <Icon name="warning" className="mr-2"/> {t('contactEditContactDirectoryWarning')}
                </div>
            }
            <form action="" method="post" autoComplete="off" onSubmit={proceed}>
                <div className="contact-edit-body">
                    <div className="d-flex align-items-center my-4">
	                    <div className="position-relative">
                            <Avatar
                                editableAvatar={findContactDetails.editable}
                                browseHandler={browseHandler}
                                clickHandler={clickHandler}
                                className="mr-3"
                                size={'4em'}
                                src={
                                    readFile === ""
                                    ?
                                        findContactDetails.imageString !== ''
                                            ?
                                            findContactDetails.hasImage
                                                ?
                                                'data:image/png;base64,' + findContactDetails.imageString
                                                :
                                                findContactDetails.imageString
                                            :
                                            'https://lh3.googleusercontent.com/a/default-user=s200-p-k-rw-no'
                                    :
                                        'data:image/png;base64,' + readFile
                                }
                            />
                            {
                                selectedContactsGroup && selectedContactsGroup.type === "directory"
                                    ?
                                    <svg className="directory-contact-icon" xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 48 48" xmlSpace="preserve">
                                        <path fill="#001593" d="M24 0C10.745 0 0 10.745 0 24c0 13.255 10.745 24 24 24 13.255 0 24 -10.745 24 -24C48 10.745 37.255 0 24 0z"/>
                                        <path d="M11.654 13.708h2.483v25.362h-2.483zm22.209 0h2.482v25.362h-2.482zm-18.284 25.362H20.554V34.673h6.892v4.397h4.974V8.93H15.579v30.139zm12.907 -28.126h2.487v2.764h-2.487v-2.764zm0 4.249h2.487v2.758h-2.487v-2.758zm0 4.243h2.487v2.764h-2.487v-2.764zm0 4.249h2.487v2.764h-2.487v-2.764zm0 4.778h2.487v2.758h-2.487v-2.758zm-3.82 -17.519h2.487v2.764h-2.487v-2.764zm0 4.249h2.487v2.758h-2.487v-2.758zm0 4.243h2.487v2.764h-2.487v-2.764zm0 4.249h2.487v2.764h-2.487v-2.764zm0 4.778h2.487v2.758h-2.487v-2.758zm-3.82 -17.519h2.483v2.764h-2.483v-2.764zm0 4.249h2.483v2.758h-2.483v-2.758zm0 4.243h2.483v2.764h-2.483v-2.764zm0 4.249h2.483v2.764h-2.483v-2.764zm0 4.778h2.483v2.758h-2.483v-2.758zm-3.825 -17.519h2.483v2.764h-2.483v-2.764zm0 4.249h2.483v2.758h-2.483v-2.758zm0 4.243h2.483v2.764h-2.483v-2.764zm0 4.249h2.483v2.764h-2.483v-2.764zm0 4.778h2.483v2.758h-2.483v-2.758z" fill="#FFF"/>
                                    </svg>
                                    :
                                    null
                            }
                        </div>
                        <h2 className="mb-0">
                            {
                                findContactDetails.phoneContactEntry.prefix !== undefined
                                    ?
                                    findContactDetails.phoneContactEntry.prefix + ' '
                                    :
                                    ''
                            }
                            {
                                findContactDetails.phoneContactEntry.givenName !== undefined
                                    ?
                                    findContactDetails.phoneContactEntry.givenName
                                    :
                                    ''
                            }
                            {
                                findContactDetails.phoneContactEntry.middleName !== undefined
                                    ?
                                    ' ' + findContactDetails.phoneContactEntry.middleName
                                    :
                                    ''
                            }
                            {
                                findContactDetails.phoneContactEntry.familyName !== undefined
                                    ?
                                    ' ' + findContactDetails.phoneContactEntry.familyName
                                    :
                                    ''
                            }
                            {
                                findContactDetails.phoneContactEntry.suffix !== undefined
                                    ?
                                    ' ' + findContactDetails.phoneContactEntry.suffix
                                    :
                                    ''
                            }
                        </h2>
                    </div>
                    <div className={`d-flex mb-1`}>
                        <div className="col-2">
                            <div className="form-group">
                                <label htmlFor="prefix">{t("fieldPrefix")}:</label>
                                <Input
                                    id="prefix"
                                    defaultValue={findContactDetails.phoneContactEntry.prefix}
                                    placeholder={t("fieldPrefix")}
                                    disabled={findContactDetails.phoneContactEntry.type === 'directory' && profile.accessStatus.isCustomSchemaAndDirectoryWriteGranted === false}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label htmlFor="givenName">{t("fieldFirstName")}:</label>
                                <Input
                                    id="givenName"
                                    defaultValue={findContactDetails.phoneContactEntry.givenName}
                                    placeholder={t("fieldFirstName")}
                                    disabled={findContactDetails.phoneContactEntry.type === 'directory' && profile.accessStatus.isCustomSchemaAndDirectoryWriteGranted === false}
                                />
                            </div>
                        </div>
                        <div className="col-2">
                            <div className="form-group">
                                <label htmlFor="middleName">{t("fieldMiddleName")}:</label>
                                <Input
                                    id="middleName"
                                    defaultValue={findContactDetails.phoneContactEntry.middleName}
                                    placeholder={t("fieldMiddleName")}
                                    autoComplete="off"
                                    disabled={findContactDetails.phoneContactEntry.type === 'directory' && profile.accessStatus.isCustomSchemaAndDirectoryWriteGranted === false}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label htmlFor="familyName">{t("textFamilyName")}</label>
                                <Input
                                    id="familyName"
                                    defaultValue={findContactDetails.phoneContactEntry.familyName}
                                    placeholder={t("fieldLastName")}
                                    disabled={findContactDetails.phoneContactEntry.type === 'directory' && profile.accessStatus.isCustomSchemaAndDirectoryWriteGranted === false}
                                />
                            </div>
                        </div>
                        <div className="col-2">
                            <div className="form-group">
                                <label htmlFor="suffix">{t("fieldSuffix")}:</label>
                                <Input
                                    id="suffix"
                                    defaultValue={findContactDetails.phoneContactEntry.suffix}
                                    placeholder={t("fieldSuffix")}
                                    disabled={findContactDetails.phoneContactEntry.type === 'directory' && profile.accessStatus.isCustomSchemaAndDirectoryWriteGranted === false}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={`d-flex border-top py-3 mb-1`}>
                        <div className="form-group col-4">
                            <label htmlFor="company">{t("fieldCompany")}:</label>
                            <Input
                                id="company"
                                defaultValue={findContactDetails.phoneContactEntry.company}
                                placeholder={t("fieldCompany")}
                            />
                        </div>
                        <div className="form-group col-4">
                            <label htmlFor="jobTitle">{t("fieldJob")}:</label>
                            <Input
                                id="jobTitle"
                                defaultValue={findContactDetails.phoneContactEntry.jobTitle}
                                placeholder={t("fieldJob")}
                            />
                        </div>
                        <div className="form-group col-4">
                            <label htmlFor="department">{t("fieldDepartment")}:</label>
                            <Input
                                id="department"
                                defaultValue={findContactDetails.phoneContactEntry.department}
                                placeholder={t("fieldDepartment")}
                            />
                        </div>
                    </div>
                    <ContactEditEmailRows email={action && contactEmail}/>
                    <ContactEditPhoneRows/>
                    <ContactEditPostalAddressRows/>
                    <div className={`d-flex border-top py-3 mb-1`}>
                        <div className="col-1 d-flex align-items-center justify-content-center">
                            <svg width="20" height="20" viewBox="0 0 24 24">
                                <path d="M0 0h24v24H0V0z" fill="none"/>
                                <path d="M19 14v-4c0-1.1-.9-2-2-2h-4V6.55c.15-.09.29-.18.41-.31.39-.39.59-.92.59-1.42s-.2-1.02-.59-1.41L12
                                 2l-1.41 1.41c-.39.39-.59.91-.59 1.41s.2 1.03.59 1.42c.13.13.27.22.41.31V8H7c-1.1 0-2
                                 .9-2 2v4c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zM7
                                 10h10v4H7v-4zm12 10H5v-4h14v4z"/></svg>
                        </div>
                        <div className="col-11">
                            <Input
                                type="date"
                                id="birthday"
                            />
                        </div>
                    </div>
                    <div className="d-flex py-4 border-top align-items-start">
                        <div className="col-1 d-flex align-items-start justify-content-center">
                            <svg width="20" height="20" viewBox="0 0 24 24">
                                <path fill="none" d="M0 0h24v24H0V0z"/>
                                <path
                                    d="M16 4H4c-1.1 0-2 .9-2 2v12.01c0 1.1.9 1.99 2 1.99h16c1.1 0 2-.9 2-2v-8l-6-6zM4 18.01V6h11v5h5v7.01H4z"/>
                            </svg>
                        </div>
                        <div className="col-11">
                            <textarea
                                className="form-control"
                                name="description"
                                id="description"
                                rows="2"
                                placeholder={t("fieldDescriptionPlaceholder")}
                                defaultValue={findContactDetails.phoneContactEntry.note}
                            />
                        </div>
                    </div>
                    {
                        findContactDetails.phoneContactEntry.userDefined &&
                        <div className="contact-edit-custom-fields py-4 border-top align-items-start">
                            {
                                findContactDetails.phoneContactEntry.userDefined.map((item, index) => (
                                    <div key={index} className="d-flex contact-edit-custom-field mb-3">
                                        <div className="col-1 d-flex align-items-center justify-content-center">
                                            <svg
                                                height="20"
                                                viewBox="0 -960 960 960"
                                                width="20"
                                            >
                                                <path
                                                    d="M200-520q-33 0-56.5-23.5T120-600v-160q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v160q0 33-23.5 56.5T760-520H200Zm0-80h560v-160H200v160Zm0 480q-33 0-56.5-23.5T120-200v-160q0-33 23.5-56.5T200-440h560q33 0 56.5 23.5T840-360v160q0 33-23.5 56.5T760-120H200Zm0-80h560v-160H200v160Zm0-560v160-160Zm0 400v160-160Z"/>
                                            </svg>
                                        </div>
                                        <div className="col-11">
                                            <p>{item.key}:</p>
                                            {
                                                item.customFieldValueType === "TEXT"
                                                ?
                                                    <>
                                                        <Input
                                                            type="text"
                                                            id={`edit-contact-custom-field-value-${index}`}
                                                            defaultValue={item.value}
                                                        />
                                                    </>
                                                :
                                                    <select
                                                        defaultValue={item.value}
                                                        className="form-control"
                                                        id={`edit-contact-custom-field-value-${index}`}
                                                    >
	                                                    <option value="">---- Select a value ----</option>
                                                        {
                                                            customFieldsForContactForm.customFields.map( (customField) => {
                                                                if (customField.label === item.key) {
                                                                    return customField.dropdownOptions.map( (dropdownOption) => (
                                                                        <option key={dropdownOption.id} value={dropdownOption.name}>{dropdownOption.name}</option>
                                                                    ))
                                                                } else {
                                                                    return null
                                                                }
                                                            })
                                                        }
                                                    </select>
                                            }
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    }
                </div>

                <div className="d-flex align-items-center justify-content-end w-100">
                    {
                        isSubmitting
                            ?
                            <React.Fragment>
                                <Button className="btn-primary font-weight-bold" disabled={true}>
                                    <Icon animated={'pulse'} name="spinner"/>
                                </Button>
                            </React.Fragment>
                            :
                            <React.Fragment>
                                <Button className='btn-outline-primary mr-3'
                                        onClick={goBackToView}>{t("textCancel")}</Button>
                                <Button className='btn-primary' type='submit'>{t("textSave")}</Button>
                            </React.Fragment>
                    }
                </div>
            </form>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        findContactDetails: state.contactDetailsReducer.findContactDetails,
        sharingDetailsPopup: state.sharingDetailsReducer.getSharingDetailsPopup,
        checkGmailAddOnData: state.profileReducer.setGmailAddOnData,
        contactSearchResult: state.contactReducer.contactSearchResult,
        selectedContactsGroup: state.contactsGroupItemReducer.getSelectedContactsGroup,
        customFieldsForContactForm: state.customFieldsReducer.customFieldsForContactForm,
	    profile: state.profileReducer.getProfile
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        setContactDetailsEditMode: (boolean) => {
            dispatch(contactDetailsEditMode(boolean))
        },
        putUpdateContact: (contactId, object, ownerId) => {
            dispatch(putUpdateContact(contactId, object, ownerId, ownProps))
        },
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ContactEdit));
